module.exports = __webpack_public_path__ + "images/enable-prices-b6c4fe7b42c53fda1b9aac802ba700ef.jpg";